export enum ServiceHistoryTab {
  Waypoints = 'waypoints',
  Services = 'services',
}
